

import { Box, Card, Grid, IconButton, Step, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useLocation } from "react-router-dom";
import { MultiPartScreens } from './multiStepScreens';
import { emptyValues,previousStep } from '../../../slice/multiStepSlice';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Stack from '@mui/material/Stack';

export const GenericMultiStep = () => {
    const mobileMedia = useMediaQuery({ maxWidth: 576 });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { step, values } = useSelector((state) => state?.multiStep);
    console.log("step----",step,"<<<<<values>>>>>>>>>>>>>>", values);



    return (
        <Grid container>
 
            {(step === 4 || step === 6) ? (
                <Stack spacing={2} direction="row" >
                    <IconButton    onClick={() => dispatch(previousStep())} sx={{ color: "#000000" }}>
                        {/* Custom Icon for Step 4 and 6 */}
                        <ChevronLeftIcon />
                        <Typography variant="body1" sx={{ fontWeight: 500 }} > {/* Adjust styles if needed */}
                            Back
                        </Typography> {/* You can change color or icon here */}
                    </IconButton>

                </Stack>
            ) : (
                !(step > 0 && !values.REDIRECT) && (
                    // Default Back Icon for other steps
                    <Box
                        onClick={() => {
                            dispatch(emptyValues());
                            navigate(-1);
                        }}
                        sx={{


                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer'
                        }}
                    >
                        <IconButton>
                            <ChevronLeftIcon />
                        </IconButton>
                        <Typography variant="body1">
                            Back
                        </Typography>
                    </Box>
                )
            )}


            <Grid lg={6} style={mobileMedia ? { paddingTop: 20 } : { marginTop: 20 }} />

            {step === 1 && state === "OnBoardingDocuments" ? (
                <MultiPartScreens screen={state} />
            ) : [4, 6].includes(step) && state === "Specialties" ? (
                <MultiPartScreens screen={state} />
            ) : state === "LearningDocuments" ? (
                <MultiPartScreens screen={state} />
            ) :

                (
                    <Grid container style={{ justifyContent: "center" }}>
                        <Grid item lg={4} sx={{ width: "auto", background: "transparent" }}>
                            <Box px={4} sx={{ cursor: "pointer" }}></Box>
                            <Card style={step === 8 ? { background: "transparent", boxShadow: "none" } : {}}>
                                <MultiPartScreens screen={state} />
                            </Card>



                        </Grid>
                    </Grid>
                )}


        </Grid>
    );
};
